import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export type OnlyContactInformation = keyof Omit<
  ContactInformation,
  'scaredOfDentist' | 'termsAndConditions' | 'msgToClinic' | 'success' | 'error'
>

export type ContactInformation = {
  fName: string | null
  lName: string | null
  email: string | null
  phone: string | null
  ssn: string | null
  msgToClinic: {
    msg: string | null
    phobia: string | null
  }
  scaredOfDentist: boolean
  termsAndConditions: boolean
}

export const initialState: ContactInformation = {
  fName: null,
  lName: null,
  email: null,
  phone: null,
  ssn: null,
  msgToClinic: {
    msg: null,
    phobia: null,
  },
  scaredOfDentist: false,
  termsAndConditions: false,
}

export const ContactInformationScreenSlice = createSlice({
  name: 'contactInformationScreen',
  initialState,
  reducers: {
    setContactInformation: (
      state,
      action: PayloadAction<{
        name: OnlyContactInformation
        value: string
      }>
    ) => {
      const { name, value } = action.payload
      state[name] = value
    },
    setCheckedOptions: (
      state,
      action: PayloadAction<{
        name: keyof Pick<
          ContactInformation,
          'scaredOfDentist' | 'termsAndConditions'
        >
        value: boolean
      }>
    ) => {
      const { name, value } = action.payload
      state[name] = value
    },
    setMessages: (
      state,
      action: PayloadAction<{
        name: 'msg' | 'phobia'
        value: string
      }>
    ) => {
      const { name, value } = action.payload
      state.msgToClinic[name] = value
    },
    clearState: () => initialState,
  },
})

export const {
  setContactInformation,
  setCheckedOptions,
  setMessages,
  clearState,
} = ContactInformationScreenSlice.actions
export const stateContactInformation = (state: RootState) =>
  state.contactInformationScreen
export default ContactInformationScreenSlice.reducer
